import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import LoginPage from './component/login/LoginPage';
import ProtectedRoute from './component/ProtectedRoute';

// import Home from './component/home/Home';
import FundRelease from './component/fund_request/FundRelease';
import FundAllocation from './component/fund_request/FundAllocation';
import FundRequest from './component/fund_request/FundRequest';
import FundFristLvlVerification from './component/fund_request/FundFristLvlVerification';
import FundApproval from './component/fund_request/FundApproval';
import FundSecLevelVerification from './component/fund_request/FundSecLevelVerification';
import FundRefund from './component/fund_request/FundRefund';
import FundAudit from './component/fund_request/FundAudit';
import UploadRecipetCopy from './component/fund_request/UploadRecipetCopy';

import BillAuditing from './component/billings/BillAuditing';
import BillSubmission from './component/billings/BillSubmission';
import ConsleBillGen from './component/billings/ConsleBillGen';
import FirstLevelBill from './component/billings/FirstLevelBill';
import JobAuditing from './component/billings/JobAuditing';
import SecondLvl from './component/billings/SecondLvl';
import SepratedBill from './component/billings/SperatedBillgen/SepratedBill';
import QuotationImporter from './component/Master/QuotationImporter';
import QuotationForwarder from './component/Master/QuotationForwarder';
import CustomActivity from './component/CustomActivity/CustomActivity';
import BeSbUpdation from './component/besb_updation/BeSbUpdation';
import Tracking from './component/tracking/Tracking';

import FundRefundReport from './component/Reports/FundReports/FundRefundReports'
import FundStatus from './component/Reports/FundReports/FundStatus'
import DSR1 from './component/Reports/DailyStatusReports/DSR1'
import DSR2 from './component/Reports/DailyStatusReports/DSR2'
import DSR3 from './component/Reports/DailyStatusReports/DSR3'
import BillDetailsReport from './component/Reports/BillReports/BillDetailsReport'
import BillSummaryReport from './component/Reports/BillReports/BillSummaryReport'
import GSTR1Reports from './component/Reports/BillReports/GSTR1Reports'
import ConsoleBillInvoiceReport from './component/Reports/BillReports/ConsoleBillInvoiceReport'
import CustomerWiseBillReports from './component/Reports/BillReports/CustomerWiseBillReports'
import InvoiceBillDownload from './component/Reports/BillReports/InvoiceBillDownload'
import MultipleBillDownload from './component/Reports/BillReports/MultipleBillDownload'
import QuotationDownload from './component/Reports/BillReports/QuotationDownload'
import TallyIntegrationReport from './component/Reports/BillReports/TallyIntegrationReport'
import SupplimentaryBillReport from './component/Reports/BillReports/SupplimentaryBillReport'
import BillingDepartmentEmployeeReport from './component/Reports/OperationReports/BillingDepartmentEmployeeReport'
import BillingWiseReport from './component/Reports/OperationReports/BillWiseReport'
import BranchWiseReport from './component/Reports/OperationReports/BranchWiseReport';
import CustomerWiseReport from './component/Reports/OperationReports/CustomerWiseReport';
import CheckListExcelReport from './component/Reports/OperationReports/CheckListExcelReport';
import DocumentationEmployeeReport from './component/Reports/OperationReports/DocumentationEmployeeReport';
import ExpenseReport from './component/Reports/OperationReports/ExpenseReport';
import FundRequestEmployeeReport from './component/Reports/OperationReports/FundRequestEmployeeReport';
import PaymentExpenseEmployeeReport from './component/Reports/OperationReports/PaymentExpenseEmployeeReport';
import OperationDeptWiseEmployeeReport from './component/Reports/OperationReports/OperationDeptWiseEmployeeReport';
import ProfitAndLoseReport from './component/Reports/OperationReports/ProfitAndLoseReport';
import Country from './component/masterdata/Place/Country';
import State from './component/masterdata/Place/State';
import ClearanceLoc from './component/masterdata/Place/ClearanceLoc';
import Itemtype from './component/masterdata/Billing/Itemtype';
import Chargetype from './component/masterdata/Billing/Chargetype';
import Billcharge from './component/masterdata/Billing/Billcharge';
import Unitofmeasurement from './component/masterdata/Billing/Unitofmeasurement';
import Account from './component/masterdata/Accounts/Account';
import Voucher from './component/masterdata/Accounts/Voucher';
import Payment from './component/masterdata/Accounts/Payment';
import Billpaidto from './component/masterdata/Accounts/Billpaidto';
import Billpaidby from './component/masterdata/Accounts/Billpaidby';
import Printedtype from './component/masterdata/Accounts/Printedtype';
import CheckListAprovel from './component/checklist/CheckListAprovel';
import CheckListSendParty from './component/checklist/CheckListSendParty';
import CheckListVerify from './component/checklist/CheckListVerify';
import DashBoard from './component/home/DashBoard';
import BillEdit from './component/Reports/BillReports/BillEdit';
import Dutypayment from './component/job_expenses/Dutypayment';
import TSPpayment from './component/job_expenses/TSPpayment';
import CargoSheedPayment from './component/job_expenses/CargoSheedPayment';
import CustomHosePayment from './component/job_expenses/CustomHosePayment';
import MiscellaneousPayment from './component/job_expenses/MiscellaneousPayment';
import DSR4 from './component/Reports/DailyStatusReports/DSR4';
import JobReport from './component/Reports/BillReports/JobReport';
import DSR from './component/Reports/DailyStatusReports/DSR.jsx';
import Einvoice from './component/Einvoice.jsx';
import IrnUpdate from './component/IrnUpdate.jsx';
import EInvoiceReport from './component/EInvoiceReport.jsx';
// import IdleTimerContainer from './component/IdleTimerContainer';

function App() {
  return (
    <div >
      {/* <IdleTimerContainer> */}
      {/* ngp_erp_ngpsoftware  ngp_erp  */}
      <BrowserRouter basename={'/ngp_erp'}>
        {/* <BrowserRouter basename={'/ngp_erp_v2'}> */}
        <Routes>
          {/* Public Route */}
          <Route exact path="/" element={<LoginPage />} />
          <Route exact path="*" element={<LoginPage />} />

          {/* Protected Routes */}
          <Route path="/home" element={<ProtectedRoute><DashBoard /></ProtectedRoute>} />

          <Route path="/billaudit" element={<ProtectedRoute><BillAuditing /></ProtectedRoute>} />
          <Route path="/billSub" element={<ProtectedRoute><BillSubmission /></ProtectedRoute>} />
          <Route path="/conslBills" element={<ProtectedRoute><ConsleBillGen /></ProtectedRoute>} />
          <Route path="/1stlvl" element={<ProtectedRoute><FirstLevelBill /></ProtectedRoute>} />
          <Route path="/2ndlvl" element={<ProtectedRoute><SecondLvl /></ProtectedRoute>} />
          <Route path="/jobAudit" element={<ProtectedRoute><JobAuditing /></ProtectedRoute>} />
          <Route path="/sepbill" element={<ProtectedRoute><SepratedBill /></ProtectedRoute>} />

          <Route path="/qutationImporter" element={<ProtectedRoute><QuotationImporter /></ProtectedRoute>} />
          <Route path="/qutationForwarder" element={<ProtectedRoute><QuotationForwarder /></ProtectedRoute>} />
          <Route path="/customactivity" element={<ProtectedRoute><CustomActivity /></ProtectedRoute>} />
          <Route path="/besbupdation" element={<ProtectedRoute><BeSbUpdation /></ProtectedRoute>} />
          <Route path="/tracking" element={<ProtectedRoute><Tracking /></ProtectedRoute>} />

          <Route path="/fundreq" element={<ProtectedRoute><FundRequest /></ProtectedRoute>} />
          <Route path="/fundaprvl" element={<ProtectedRoute><FundApproval /></ProtectedRoute>} />
          <Route path="/fund1stlvlvrfy" element={<ProtectedRoute><FundFristLvlVerification /></ProtectedRoute>} />
          <Route path="/fund2ndlvlvrfy" element={<ProtectedRoute><FundSecLevelVerification /></ProtectedRoute>} />
          <Route path="/fundallocation" element={<ProtectedRoute><FundAllocation /></ProtectedRoute>} />
          <Route path="/fundrels" element={<ProtectedRoute><FundRelease /></ProtectedRoute>} />
          <Route path="/fundrefund" element={<ProtectedRoute><FundRefund /></ProtectedRoute>} />
          <Route path="/fundaudit" element={<ProtectedRoute><FundAudit /></ProtectedRoute>} />
          <Route path="/fund_rcptCpy" element={<ProtectedRoute><UploadRecipetCopy /></ProtectedRoute>} />

          {/* Reports */}
          <Route path="/FundRefundReport" element={<ProtectedRoute><FundRefundReport /></ProtectedRoute>} />
          <Route path="/billedit" element={<ProtectedRoute><BillEdit /></ProtectedRoute>} />
          <Route path="/FundStatus" element={<ProtectedRoute><FundStatus /></ProtectedRoute>} />
          <Route path="/DSR1" element={<ProtectedRoute><DSR1 /></ProtectedRoute>} />
          <Route path="/DSR2" element={<ProtectedRoute><DSR2 /></ProtectedRoute>} />
          <Route path="/DSR3" element={<ProtectedRoute><DSR3 /></ProtectedRoute>} />
          <Route path="/DSR4" element={<ProtectedRoute><DSR4 /></ProtectedRoute>} />
          <Route path="/DSR" element={<ProtectedRoute><DSR /></ProtectedRoute>} />
          <Route path="/BillDetailsReport" element={<ProtectedRoute><BillDetailsReport /></ProtectedRoute>} />
          <Route path="/BillSummaryReport" element={<ProtectedRoute><BillSummaryReport /></ProtectedRoute>} />
          <Route path="/GSTR1Reports" element={<ProtectedRoute><GSTR1Reports /></ProtectedRoute>} />
          <Route path="/ConsoleBillInvoiceReport" element={<ProtectedRoute><ConsoleBillInvoiceReport /></ProtectedRoute>} />
          <Route path="/CustomerWiseBillReports" element={<ProtectedRoute><CustomerWiseBillReports /></ProtectedRoute>} />
          <Route path="/InvoiceBillDownload" element={<ProtectedRoute><InvoiceBillDownload /></ProtectedRoute>} />
          <Route path="/MultipleBillDownload" element={<ProtectedRoute><MultipleBillDownload /></ProtectedRoute>} />
          <Route path="/QuotationDownload" element={<ProtectedRoute><QuotationDownload /></ProtectedRoute>} />
          <Route path="/TallyIntegrationReport" element={<ProtectedRoute><TallyIntegrationReport /></ProtectedRoute>} />
          <Route path="/SupplimentaryBillReport" element={<ProtectedRoute><SupplimentaryBillReport /></ProtectedRoute>} />
          <Route path="/BillingDepartmentEmployeeReport" element={<ProtectedRoute><BillingDepartmentEmployeeReport /></ProtectedRoute>} />
          <Route path="/BillingWiseReport" element={<ProtectedRoute><BillingWiseReport /></ProtectedRoute>} />
          <Route path="/BranchWiseReport" element={<ProtectedRoute><BranchWiseReport /></ProtectedRoute>} />
          <Route path="/CustomerWiseReport" element={<ProtectedRoute><CustomerWiseReport /></ProtectedRoute>} />
          <Route path="/ExpenseReport" element={<ProtectedRoute><ExpenseReport /></ProtectedRoute>} />
          <Route path="/ChecklistExcelReport" element={<ProtectedRoute><CheckListExcelReport /></ProtectedRoute>} />
          <Route path="/DocumentationEmployeeReport" element={<ProtectedRoute><DocumentationEmployeeReport /></ProtectedRoute>} />
          <Route path="/FundRequestEmployeeReport" element={<ProtectedRoute><FundRequestEmployeeReport /></ProtectedRoute>} />
          <Route path="/ProfitAndLoseReport" element={<ProtectedRoute><ProfitAndLoseReport /></ProtectedRoute>} />
          <Route path="/PaymentExpenseEmployeeReport" element={<ProtectedRoute><PaymentExpenseEmployeeReport /></ProtectedRoute>} />
          <Route path="/OperationDeptWiseEmployeeReport" element={<ProtectedRoute><OperationDeptWiseEmployeeReport /></ProtectedRoute>} />
          <Route path="/Country" element={<ProtectedRoute><Country /></ProtectedRoute>} />
          <Route path="/State" element={<ProtectedRoute><State /></ProtectedRoute>} />
          <Route path="/ClearanceLoc" element={<ProtectedRoute><ClearanceLoc /></ProtectedRoute>} />
          <Route path="/Itemtype" element={<ProtectedRoute><Itemtype /></ProtectedRoute>} />
          <Route path="/Chargetype" element={<ProtectedRoute><Chargetype /></ProtectedRoute>} />
          <Route path="/Billcharge" element={<ProtectedRoute><Billcharge /></ProtectedRoute>} />
          <Route path="/Unitofmeasurement" element={<ProtectedRoute><Unitofmeasurement /></ProtectedRoute>} />
          <Route path="/Account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/Voucher" element={<ProtectedRoute><Voucher /></ProtectedRoute>} />
          <Route path="/Billpaidto" element={<ProtectedRoute><Billpaidto /></ProtectedRoute>} />
          <Route path="/Billpaidby" element={<ProtectedRoute><Billpaidby /></ProtectedRoute>} />
          <Route path="/Payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
          <Route path="/Printedtype" element={<ProtectedRoute><Printedtype /></ProtectedRoute>} />

          <Route path="/checklistApprovalbMngr" element={<ProtectedRoute><CheckListAprovel /></ProtectedRoute>} />
          <Route path="/checklistSndParty" element={<ProtectedRoute><CheckListSendParty /></ProtectedRoute>} />
          <Route path="/checklistVerify" element={<ProtectedRoute><CheckListVerify /></ProtectedRoute>} />

          <Route path="/duty_payment" element={<ProtectedRoute><Dutypayment /></ProtectedRoute>} />
          <Route path="/tsp_payment" element={<ProtectedRoute><TSPpayment /></ProtectedRoute>} />
          <Route path="/cargo_payment" element={<ProtectedRoute><CargoSheedPayment /></ProtectedRoute>} />
          <Route path="/cusHous_payment" element={<ProtectedRoute><CustomHosePayment /></ProtectedRoute>} />
          <Route path="/misce_payment" element={<ProtectedRoute><MiscellaneousPayment /></ProtectedRoute>} />
          <Route path="/jobreport" element={<ProtectedRoute><JobReport /></ProtectedRoute>} />
          <Route path="/einvoice" element={<ProtectedRoute><Einvoice /></ProtectedRoute>} />
          <Route path="/irnupdate" element={<ProtectedRoute><IrnUpdate /></ProtectedRoute>} />
          <Route path="/e-invoice-report" element={<ProtectedRoute><EInvoiceReport /></ProtectedRoute>} />
        </Routes>

      </BrowserRouter>
      {/* </IdleTimerContainer> */}
    </div>
  );
}

export default App;
